import { __spreadArray } from "tslib";
import { installClientScript } from './install';
var INITIALIZER_GLOBAL_KEY = '_statistClientInitializer';
var StatistClientProxy = /** @class */ (function () {
    function StatistClientProxy() {
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        var _this = this;
        this.resolveClient = function () { };
        this.clientPromise = new Promise(function (resolve) {
            _this.resolveClient = resolve;
        });
        this.updateUserProperties = this.createEnqueuedClientMethod('updateUserProperties');
        this.updateABGroups = this.createEnqueuedClientMethod('updateABGroups');
        this.updateFeatureFlags = this.createEnqueuedClientMethod('updateFeatureFlags');
        this.on = this.createEnqueuedClientMethod('on');
        this.off = this.createEnqueuedClientMethod('off');
        this.forceSend = this.createEnqueuedClientMethod('forceSend');
        var initializeClient = function (initializer) {
            var client = initializer.apply(void 0, params);
            _this.client = client;
            _this.resolveClient(client);
        };
        var initializer = window[INITIALIZER_GLOBAL_KEY];
        if (initializer) {
            initializeClient(initializer);
        }
        else {
            this.interceptClientInitialization(initializeClient);
            installClientScript();
        }
    }
    StatistClientProxy.prototype.interceptClientInitialization = function (initializeClient) {
        var currentDescriptor = Object.getOwnPropertyDescriptor(window, INITIALIZER_GLOBAL_KEY);
        Object.defineProperty(window, INITIALIZER_GLOBAL_KEY, {
            configurable: true,
            set: function (initializer) {
                var _a;
                (_a = currentDescriptor === null || currentDescriptor === void 0 ? void 0 : currentDescriptor.set) === null || _a === void 0 ? void 0 : _a.call(currentDescriptor, initializer);
                initializeClient(initializer);
            },
        });
    };
    StatistClientProxy.prototype.enqueueCall = function (callback) {
        return this.client ? Promise.resolve(callback(this.client)) : this.clientPromise.then(callback);
    };
    StatistClientProxy.prototype.createEnqueuedClientMethod = function (method) {
        var _this = this;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            _this.enqueueCall(function (client) {
                var _a;
                (_a = client[method]) === null || _a === void 0 ? void 0 : _a.call.apply(_a, __spreadArray([client], args, false));
            });
        };
    };
    StatistClientProxy.prototype.send = function (project, event, parameters, clientParameters) {
        this.enqueueCall(function (client) {
            return client.send(project, event, parameters, clientParameters);
        });
    };
    return StatistClientProxy;
}());
export { StatistClientProxy };
//# sourceMappingURL=proxy.js.map